// core
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// components
import { EmptyLayoutComponent } from '@open-portal-app/layout/empty-layout/empty-layout.component';
import { LoginComponent } from '@open-portal-app/layout/login/login.component';
import { LogoutComponent } from '@open-portal-app/layout/logout/logout.component';
import { MagicLinkExpiredComponent } from '@open-portal-app/layout/magic-link-expired/magic-link-expired.component';
import { MainLayoutComponent } from '@open-portal-app/layout/main-layout/main-layout.component';
import { PageBadRequestComponent } from '@open-portal-app/layout/page-bad-request/page-bad-request.component';
import { PageNotFoundComponent } from '@open-portal-app/layout/page-not-found/page-not-found.component';
import { PageUnauthorisedComponent } from '@open-portal-app/layout/page-unauthorised/page-unauthorised.component';
import { HandoverGuard } from '@open-portal-app/core/guards/handover.guard';
import { LoginResolver } from '@open-portal-app/core/resolvers/login.resolver';
import { BasicLayoutComponent } from '@open-portal-app/layout/basic-layout/basic-layout.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [HandoverGuard]
  },
  {
    path: 'dashboard',
    component: MainLayoutComponent,
    data: { pageType: 'dashboard' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/dashboard/dashboard.module').then((m) => m.DashboardModule) }
    ]
  },
  {
    path: 'quote',
    component: MainLayoutComponent,
    data: { pageType: 'quoteFlow' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/quote/quote.module').then((m) => m.QuoteModule) }
    ]
  },
  {
    path: 'policy',
    component: MainLayoutComponent,
    data: { pageType: 'policyView' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/policy/policy.module').then((m) => m.PolicyModule) }
    ]
  },
  {
    path: 'user',
    component: MainLayoutComponent,
    data: { pageType: 'policyView' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/user/user.module').then((m) => m.UserModule) }
    ]
  },
  {
    path: 'endorsement',
    component: MainLayoutComponent,
    data: { pageType: 'endorsementFlow' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/endorsement/endorsement.module').then((m) => m.EndorsementModule) }
    ]
  },
  {
    path: 'prerenewal',
    component: MainLayoutComponent,
    data: { pageType: 'prerenewalFlow' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/prerenewal/prerenewal.module').then((m) => m.PreRenewalModule) }
    ]
  },
  {
    path: 'cancellation',
    component: MainLayoutComponent,
    data: { pageType: 'cancellationFlow' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/cancellation/cancellation.module').then((m) => m.CancellationModule) }
    ]
  },
  {
    path: 'refer',
    component: MainLayoutComponent,
    data: { pageType: 'landingPage' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/refer/refer.module').then((m) => m.ReferModule) }
    ]
  },
  {
    path: 'support',
    component: MainLayoutComponent,
    data: { pageType: 'supportFlow' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/help/help.module').then((m) => m.HelpModule) }
    ]
  },
  {
    path: 'appointments',
    component: MainLayoutComponent,
    data: { pageType: 'appointmentFlow' },
    children: [
      {
        path: '',
        loadChildren: () => import('@open-portal-app/appointments/appointments.module').then(
          (m) => m.AppointmentsModule
        )
      }
    ]
  },
  {
    path: 'request',
    component: MainLayoutComponent,
    data: { pageType: 'requestFlow' },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@open-portal-app/request/request.module').then(
            (m) => m.RequestModule
          ),
      }
    ]
  },
  {
    path: 'emergency',
    component: MainLayoutComponent,
    data: { pageType: 'contact' },
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/emergency/emergency.module').then((m) => m.EmergencyModule) }
    ]
  },
  {
    path: 'important-documents',
    component: MainLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/documents/documents.module').then((m) => m.DocumentsModule) }
    ]
  },
  {
    path: 'overview',
    component: BasicLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/overview/overview.module').then((m) => m.OverviewModule) }
    ]
  },
  {
    path: 'device',
    component: BasicLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('@open-portal-app/device/device.module').then((m) => m.DeviceModule) }
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
    resolve: { partnerLoginDetails: LoginResolver }
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'magic-link',
    component: MagicLinkExpiredComponent // TODO: build magic link page
  },
  {
    path: 'unauthorised',
    component: PageUnauthorisedComponent
  },
  {
    path: 'not-found',
    component: PageNotFoundComponent
  },
  {
    path: 'bad-request',
    component: PageBadRequestComponent // TODO: build bad request error page
  },
  {
    path: '**',
    component: EmptyLayoutComponent,
    children: [
      { path: '', component: PageNotFoundComponent, pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
